import React from 'react';
import { twJoin } from 'tailwind-merge';
import { StandaloneCtaTile } from './types/StandaloneCtaTile';
import ButtonLink from '../../shared/ButtonLink';

export default function StandaloneCta({
  tile,
  trackingPrefix,
}: Readonly<{
  tile: StandaloneCtaTile;
  trackingPrefix?: string;
}>) {
  const align = tile.align.options?.[0].value;

  let alignClass;
  switch (align) {
    case 'left':
      alignClass = 'ml-0';
      break;
    case 'center':
      alignClass = 'mx-auto';
      break;
    case 'right':
      alignClass = 'ml-auto';
      break;
    default:
      alignClass = 'mx-auto';
      break;
  }

  return (
    <div className="mx-auto mb-8 max-w-screen-2xl px-4 sm:mb-14 sm:px-8 lg:mb-16">
      <ButtonLink
        ctaComponent={tile.cta}
        className={twJoin(' w-fit', alignClass)}
        trackingPrefix={trackingPrefix}
      />
    </div>
  );
}
